define("shared/components/shared/post/secondary/publishing-method-setup/auto-publish-setup/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/runloop", "@ember/service", "@glimmer/component", "ember-concurrency", "later/utils/object-promise-proxy", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _runloop, _service, _component2, _emberConcurrency, _objectPromiseProxy, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _displaySuccessAlert;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/runloop",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"later/utils/object-promise-proxy",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if @socialProfile.isInstagram}}
    {{#if @socialProfile.isProfessional}}
      {{! Enable Auto Publish - Instagram }}
      <Shared::Post::Secondary::PublishingMethodSetup::Layout
        @image="/assets/images/img--nonPublishedPosts--setUp__ig__auto__publishing.png"
        @title={{t "onboarding.side_wiz.general.set_up_auto_publishing.heading"}}
      >
        <:body>
          <Shared::Post::Secondary::PublishingMethodSetup::AutoPublishSetup::EnableInstagram />
        </:body>
        <:footer>
          <Shared::Ui::Button
            @additional="block"
            @isDisabled={{this.connectFacebook.isRunning}}
            @text={{t "onboarding.side_wiz.general.set_up_auto_publishing.btn_connect_facebook"}}
            @variant="primary"
            class="qa--setup_fbconnect_btn"
            {{on "click" (perform this.connectFacebook)}}
          />
          <Shared::Ui::Button
            @additional="block"
            @onClick={{@handleClose}}
            @text={{t "onboarding.side_wiz.general.cancel"}}
            @variant="outline"
            class="qa--setup_cancel_btn"
          />
        </:footer>
      </Shared::Post::Secondary::PublishingMethodSetup::Layout>
    {{else}}
      {{! Switch to Business - Instagram }}
      <Shared::Post::Secondary::PublishingMethodSetup::Layout
        @image="/assets/images/img--nonPublishedPosts--switching__ig__business__profile.png"
        @title={{t "onboarding.side_wiz.general.set_up_auto_publishing.heading2"}}
      >
        <:body>
          <Shared::Post::Secondary::PublishingMethodSetup::AutoPublishSetup::SwitchBusinessInstagram />
        </:body>
        <:footer>
          <Shared::Ui::Button
            @additional="block"
            @text={{t "onboarding.side_wiz.general.set_up_auto_publishing.btn_update"}}
            @variant="primary"
            {{on "click" (perform this.checkProfileType)}}
          />
          <Shared::Ui::Button
            @additional="block"
            @text={{t "onboarding.side_wiz.general.cancel"}}
            @variant="outline"
            {{on "click" @handleClose}}
          />
        </:footer>
      </Shared::Post::Secondary::PublishingMethodSetup::Layout>
    {{/if}}
  {{/if}}
  */
  {
    "id": "jebbn1Gg",
    "block": "[[[41,[30,1,[\"isInstagram\"]],[[[41,[30,1,[\"isProfessional\"]],[[[1,\"    \"],[8,[39,1],null,[[\"@image\",\"@title\"],[\"/assets/images/img--nonPublishedPosts--setUp__ig__auto__publishing.png\",[28,[37,2],[\"onboarding.side_wiz.general.set_up_auto_publishing.heading\"],null]]],[[\"body\",\"footer\"],[[[[1,\"\\n        \"],[8,[39,3],null,null,null],[1,\"\\n      \"]],[]],[[[1,\"\\n        \"],[8,[39,4],[[24,0,\"qa--setup_fbconnect_btn\"],[4,[38,5],[\"click\",[28,[37,6],[[30,0,[\"connectFacebook\"]]],null]],null]],[[\"@additional\",\"@isDisabled\",\"@text\",\"@variant\"],[\"block\",[30,0,[\"connectFacebook\",\"isRunning\"]],[28,[37,2],[\"onboarding.side_wiz.general.set_up_auto_publishing.btn_connect_facebook\"],null],\"primary\"]],null],[1,\"\\n        \"],[8,[39,4],[[24,0,\"qa--setup_cancel_btn\"]],[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,2],[28,[37,2],[\"onboarding.side_wiz.general.cancel\"],null],\"outline\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,1],null,[[\"@image\",\"@title\"],[\"/assets/images/img--nonPublishedPosts--switching__ig__business__profile.png\",[28,[37,2],[\"onboarding.side_wiz.general.set_up_auto_publishing.heading2\"],null]]],[[\"body\",\"footer\"],[[[[1,\"\\n        \"],[8,[39,7],null,null,null],[1,\"\\n      \"]],[]],[[[1,\"\\n        \"],[8,[39,4],[[4,[38,5],[\"click\",[28,[37,6],[[30,0,[\"checkProfileType\"]]],null]],null]],[[\"@additional\",\"@text\",\"@variant\"],[\"block\",[28,[37,2],[\"onboarding.side_wiz.general.set_up_auto_publishing.btn_update\"],null],\"primary\"]],null],[1,\"\\n        \"],[8,[39,4],[[4,[38,5],[\"click\",[30,2]],null]],[[\"@additional\",\"@text\",\"@variant\"],[\"block\",[28,[37,2],[\"onboarding.side_wiz.general.cancel\"],null],\"outline\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]]]],[]],null]],[\"@socialProfile\",\"@handleClose\"],false,[\"if\",\"shared/post/secondary/publishing-method-setup/layout\",\"t\",\"shared/post/secondary/publishing-method-setup/auto-publish-setup/enable-instagram\",\"shared/ui/button\",\"on\",\"perform\",\"shared/post/secondary/publishing-method-setup/auto-publish-setup/switch-business-instagram\"]]",
    "moduleName": "shared/components/shared/post/secondary/publishing-method-setup/auto-publish-setup/index.hbs",
    "isStrictMode": false
  });
  let AutoPublishComponent = _exports.default = (_dec = (0, _service.inject)('social/instagram-auth'), (_class = (_displaySuccessAlert = /*#__PURE__*/new WeakSet(), class AutoPublishComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _displaySuccessAlert);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "segment", _descriptor3, this);
      _initializerDefineProperty(this, "instagramAuth", _descriptor4, this);
      _defineProperty(this, "checkProfileType", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const socialProfile = yield (0, _objectPromiseProxy.default)(this.socialProfile);
          this.segment.track('clicked-check-profile-type');
          yield socialProfile.get('refreshAndReload').perform();
          if (!socialProfile.isProfessional) {
            if (socialProfile.isInstagram) {
              this.alerts.alert(this.intl.t('alerts.posts.edit.instagram.creator_or_personal.message', {
                username: socialProfile.nickname
              }), {
                title: this.intl.t('alerts.posts.edit.instagram.creator_or_personal.title', {
                  username: socialProfile.nickname
                })
              });
            }
          }
        }
      }), null, "checkProfileType", null));
      _defineProperty(this, "connectFacebook", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const socialProfile = yield (0, _objectPromiseProxy.default)(this.socialProfile);
          this.segment.track('attempted-connecting-facebook');
          (0, _runloop.later)(() => {
            this.alerts.info(this.intl.t('alerts.onboarding.auto_publishing.message'), {
              title: this.intl.t('alerts.onboarding.auto_publishing.title')
            });
          }, 3000);
          if (socialProfile.isInstagramLogin) {
            this.instagramAuth.refreshInstagramLogin.perform({
              socialProfile: this.socialProfile
            });
          } else {
            yield this.instagramAuth.authenticateWithFacebookGraphApi.perform({
              refreshSocialProfiles: [socialProfile]
            });
            if (socialProfile.needsRefresh) {
              this.instagramAuth.resetInstagramAuthStatusDates();
              this.args.showInstagramAuthStatus();
            } else {
              if (this.args.shouldEnablePostAutoPublish) {
                (0, _object.set)(this.args.post, 'autoPublish', !this.args.post.autoPublish);
              }
              _classPrivateMethodGet(this, _displaySuccessAlert, _displaySuccessAlert2).call(this);
              this.args.handleClose();
            }
          }
        }
      }), null, "connectFacebook", null));
    }
    get socialProfile() {
      return this.args.socialProfile;
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "instagramAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  function _displaySuccessAlert2() {
    this.alerts.success(this.intl.t('onboarding.side_wiz.general.set_up_auto_publishing.instagram.success_alert.message', {
      username: this.socialProfile.nickname
    }), {
      title: this.intl.t('onboarding.side_wiz.general.set_up_auto_publishing.instagram.success_alert.title')
    });
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AutoPublishComponent);
});